import axios from 'axios';
import { registrarExito, registrarFallo } from '../monitoring/calidadConexion';

const baseDomain = process.env.VUE_APP_BASE_PATH;
const baseUrl = `${baseDomain}`;

const servicio = axios.create({
    baseURL : baseUrl,
    withCredentials: true
});

/**
 * Cuenta exitos y fallos para medir la calidad de la conexion del puesto.
 *
 * Hace falta aparte del `PerformanceObserver` porque la API de rendimiento no
 * reporta de forma confiable las peticiones que fallan por red, y el porcentaje
 * de fallos es justo el numero que delato el problema de Cotorra del 1-oct
 * (6,9% contra 0,0% desde una red sana).
 *
 * El interceptor NO altera la respuesta ni el error: los devuelve tal cual para
 * que ningun consumidor cambie de comportamiento. Y va envuelto en try/catch
 * porque un fallo de la telemetria no puede romper una peticion de la
 * aplicacion.
 *
 * OJO: hay 19 archivos que importan `axios` directo en vez de pasar por aqui,
 * asi que sus fallos no se cuentan todavia. Los tiempos si, porque esos los
 * captura el observador del navegador sin importar que instancia los disparo.
 */
servicio.interceptors.response.use(
    (respuesta) => {
        try {
            registrarExito(respuesta.config && respuesta.config.url);
        } catch (e) { /* la telemetria nunca rompe la peticion */ }
        return respuesta;
    },
    (error) => {
        try {
            const url = error.config && error.config.url;
            // Sin `error.response` la peticion no llego a responder: red caida,
            // timeout o DNS. Con respuesta es un error de la aplicacion (422,
            // 500) y eso no dice nada de la conexion.
            if (error.response) {
                registrarExito(url);
            } else {
                registrarFallo(url);
            }
        } catch (e) { /* la telemetria nunca rompe la peticion */ }
        return Promise.reject(error);
    }
);

export default servicio;
